import { Quill } from 'react-quill';

const Inline = Quill.import('blots/inline');

class BoldBlot extends Inline {
    static blotName = 'bold';
    static tagName = 'b';
}
Quill.register('formats/bold', BoldBlot);
export default BoldBlot;